import PropTypes from "prop-types";
import { forwardRef } from "react";

import { useFormContext } from "react-hook-form";
import { renderFinalPrice } from "helpers/utils";

import Option from "../option/Option";

const GiftWrap = forwardRef(({ id, price }, ref) => {
    const name = id ? `${id}.giftWrap.enabled` : "giftWrap.enabled";
    const optionPriceName = id ? `${id}.giftWrap.price` : "giftWrap.price";
    const quantityName = id ? `${id}.quantity` : "quantity";
    const skuName = id ? `${id}.sku` : "sku";
    const { register, watch } = useFormContext();
    const watchFields = watch([quantityName, skuName]);
    let giftwrapPrice = renderFinalPrice(price, {
        canBeZero: true
    });
    if (giftwrapPrice) {
        giftwrapPrice = `(${giftwrapPrice})`;
    }

    return (
        <>
            <Option
                name={name}
                title={`Laat je cadeaubox inpakken ${giftwrapPrice}`}
                disabled={
                    watchFields[quantityName] <= 0 ||
                    watchFields[skuName] === undefined
                }
                ref={ref}
            />
            <input
                name={optionPriceName}
                defaultValue={Number(price || 0)}
                ref={register}
                hidden
            />
        </>
    );
});

GiftWrap.displayName = "GiftWrap";

GiftWrap.defaultProps = {
    id: undefined,
    price: undefined
};

GiftWrap.propTypes = {
    id: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default GiftWrap;
